import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import UserService from '../services/UserService';
import { getToken } from '../Auth';
import './DealDetailPage.css';

// Admin page: add a new category (e.g. "Freebies") to the site.
function AddCategory() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState('');
  const [status, setStatus] = useState('idle'); // idle | saving | done | error | duplicate
  const [added, setAdded] = useState('');

  const loadCategories = () => {
    UserService.getCategory()
      .then((res) => setCategories(res.data))
      .catch((err) => console.error('Failed to load categories', err));
  };

  useEffect(loadCategories, []);

  const addCategory = (e) => {
    e.preventDefault();
    const category = name.trim();
    if (category === '') return;

    // Stop duplicates like "freebies" when "Freebies" already exists
    if (categories.some((c) => c.category.trim().toLowerCase() === category.toLowerCase())) {
      setStatus('duplicate');
      return;
    }

    setStatus('saving');
    axios.post(UserService.getURl() + '/category/add', { category }, {
      headers: { Authorization: `Bearer ${getToken()}` }
    }).then(() => {
      setAdded(category);
      setName('');
      setStatus('done');
      loadCategories();
    }).catch((err) => {
      console.error('Failed to add category', err);
      setStatus('error');
    });
  };

  return (
    <div className="detail-page">
      <div className="detail-layout page-narrow">
        <main>
          <nav className="detail-breadcrumb" aria-label="Breadcrumb">
            <Link to="/user/dashboard">Dashboard</Link>
            <span>›</span>
            <span>Add Category</span>
          </nav>

          <section className="page-card">
            <h1>Add Category</h1>
            <p className="page-intro">New categories appear in the Category menu and sidebar, and in the category list when you add deals.</p>

            <form className="page-form" onSubmit={addCategory}>
              <label>
                Category name
                <input type="text" placeholder="e.g. Freebies" value={name} required
                  onChange={(e) => { setName(e.target.value); setStatus('idle'); }} />
              </label>

              {status === 'done' && <p className="page-success-line">"{added}" was added. 🎉</p>}
              {status === 'duplicate' && <p className="page-error">That category already exists.</p>}
              {status === 'error' && <p className="page-error">Could not add the category. Are you still logged in? Try logging out and in again.</p>}

              <button type="submit" disabled={status === 'saving'}>
                {status === 'saving' ? 'Adding...' : 'Add Category'}
              </button>
            </form>

            <h2>Existing categories ({categories.length})</h2>
            <p>{categories.map((c) => c.category).join(' · ')}</p>
          </section>
        </main>
      </div>
    </div>
  );
}

export default AddCategory;
